import axios from "axios";

const instance = axios.create({
  baseURL: "https://server.wizardofswipe.com/api",
  /*
  headers: {
    //"Content-Type": "application/json",
    "Content-Type": "multipart/form-data",
  },
  */
});

instance.interceptors.request.use(
  (config) => {
    if (config.isMultipart) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    return Promise.reject(err);
  }
);

export default instance;